import emojiRegex from 'emoji-regex';
import showdown from 'showdown';
import escape from 'lodash/escape';
import replace from 'lodash/replace';

const getEscapedCodeBlockContent = (content) => {
  let cleanedContent = content;
  const rawCodeBlocks = content.matchAll(/`{3}([\S\s]*?)`{3}|`([^`]*)`|~~([\S\s]*?)~~/gm);
  if (rawCodeBlocks) {
    const codeBlocks = [...rawCodeBlocks];
    const matches = codeBlocks.map(codeBlock => codeBlock[0]);
    matches.forEach((match) => {
      const escapedMatch = escape(match);
      cleanedContent = replace(cleanedContent, match, escapedMatch);
    });
  }
  return cleanedContent;
};

export default (text, shouldFormatText = false) => {
  let content = text;

  if (shouldFormatText) {
    const converter = new showdown.Converter();
    content = converter.makeHtml(content);
    content = content.replaceAll(/\n{1,}<p>/g, '<br /><p>');
    content = content.replaceAll('&amp;nbsp;', ' ');
    // convert images back to markdown as we do not handle inline images
    content = content.replaceAll(/<img.*?src="(.*?)".*?alt="(.*?)"[^>]+>/g, (_, p1, p2) => `![${p2}](${p1})`);
  } else {
    content = getEscapedCodeBlockContent(content);
    content = content.replace(/\n{2,}/g, '<br><br>');
    content = content.replace(/\n/g, '<br>');
  }

  // replace all full-width/Japanese @ with half width
  content = content.replace(/\uFF20/g, '@');

  content = content.replace(/@\[(.+?)\](?:\((?:user-)?(\d+)\))?\s*/g, `<span class="mention" data-index="0" data-denotation-char="@" data-id="$2" data-name="$1" data-value="$1">
        <span contenteditable="false">
          <span class="ql-mention-denotation-char">
          @
          </span>
          $1
        </span>
      </span> `);

  content = content.replace(emojiRegex(), `<span class="emoji" data-native="$&">
        <span contenteditable="false">$&</span>
      </span>`);

  return content;
};
